import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { formatDateTime } from 'utils/date.utils';

interface Props {
  open: boolean;
  searchName?: string;
  nextRetryAt?: string;
  handleClose(): void;
  handleOpenAccountManagement(): void;
}

const SearchQuotaExceededDialog: React.FC<Props> = ({
  open,
  searchName,
  nextRetryAt,
  handleClose,
  handleOpenAccountManagement,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const retryAt = nextRetryAt ? formatDateTime(nextRetryAt, 'Pp') : '';

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('searchQuotaExceededModalTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.text}>
            {retryAt
              ? t('searchQuotaExceededModalContentWithDate', { searchName: searchName || '-', retryAt })
              : t('searchQuotaExceededModalContent', { searchName: searchName || '-' })}
          </Typography>
          <Typography className={classes.text}>{t('searchQuotaExceededModalContentActionHint')}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('close')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton
          text={t('searchQuotaExceededOpenAccountManagement')}
          size={'small'}
          border={'rounded'}
          action={handleOpenAccountManagement}
        />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: `linear-gradient(to right, ${theme.palette.warning.main}, ${theme.palette.warning.light})`,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default SearchQuotaExceededDialog;
